import {Controller} from "@hotwired/stimulus";
import {updateCart} from "~/lib/badges";
import {putJson} from "~/lib/request";

// Trash icon of the cart overview (carts/current). Removes the position, then
// the header badge follows and the row goes away - nothing else on the page
// depends on the cart contents, so there is no need to reload.
export default class extends Controller {
    static values = {courseUuid: String, courseRowUuid: String, removeUrl: String};

    remove() {
        if (this.pending || !this.removeUrlValue) return;
        this.pending = true;
        putJson(this.removeUrlValue, {
            course_uuid: this.courseUuidValue,
            course_row_uuid: this.courseRowUuidValue,
        }).then((data) => {
            updateCart(data.cart_count);
            this.element.closest("tr")?.remove();
        }).catch((error) => {
            console.error("removing from the cart failed", error);
            // hardcoded German like the other frontend controllers - the Vite
            // bundle has no gettext (see 15087-redesign-improvements.md, 4.4)
            window.alert("Das hat leider nicht geklappt. Bitte laden Sie die Seite neu und versuchen Sie es erneut.");
        }).finally(() => {
            this.pending = false;
        });
    }
}
